/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { theme } from '@mtsbank/ui-kit';
export const NavControl = styled.button<{
  size: number;
  variant: 'default' | 'premiumBanking';
  disabled?: boolean;
}>`
  position: relative;
  z-index: 1;
  opacity: ${({
  size
}) => size === theme.sizes.greater.md ? theme.opacities.op09 : 'unset'};
  cursor: pointer;
  width: 44px;
  height: 44px;
  border-radius: ${theme.radiuses.lg}px;
  box-shadow: ${theme.shadows.buttonDefault};
  transition: ${theme.transitions.basic};

  @media (max-width: ${theme.breakpoints.sm - 1}px) {
    width: 32px;
    height: 32px;
    box-shadow: none;
  }

  svg {
    height: 100%;
  }

  &&&:hover {
    box-shadow: ${theme.shadows.buttonHoverFocus};
  }

  &:focus {
    box-shadow: ${theme.shadows.buttonHoverFocus};
  }

  &:focus:not(:focus-visible) {
    box-shadow: ${theme.shadows.buttonDefault};
  }

  &:focus-visible {
    box-shadow: ${theme.shadows.buttonHoverFocus};
  }

  &:active {
    box-shadow: ${theme.shadows.buttonActive};
  }

  &:first-child {
    margin-right: 2px;
  }
`;
export const ControlsWrapper = styled.div<{
  top: number;
  bottom: number;
  right?: number;
}>`
  position: absolute;
  right: ${({
  right
}) => right ? `${right}px` : `${theme.spacings.md}px`};
  top: ${({
  top
}) => top ? `${top}px` : void 0};
  bottom: ${({
  bottom
}) => bottom ? `${bottom}px` : void 0};
`;